import { useInView } from "@/lib/hooks/useInView";
import { STEPS } from "./content";

export function ComoFunciona(): JSX.Element {
  const { ref, isInView } = useInView<HTMLOListElement>();

  return (
    <section id="como-funciona" aria-labelledby="how-heading" className="scroll-mt-20 border-t border-border">
      <div className="mx-auto max-w-[77.5rem] px-4 py-24 sm:px-6 lg:px-8">
        <h2
          id="how-heading"
          className="max-w-[18ch] text-[clamp(2rem,1.4rem+2.2vw,3.25rem)] font-bold leading-[1.05] tracking-[-0.035em]"
        >
          Três ajustes e o bot trabalha sozinho.
        </h2>

        <ol ref={ref} className="relative mt-16 grid gap-12 md:grid-cols-3 md:gap-8">
          <span
            aria-hidden="true"
            className="lp-line absolute left-0 right-0 top-[5px] hidden h-px bg-border-strong md:block"
            data-on={isInView}
          />
          {STEPS.map((step) => (
            <li key={step.verb} className="relative md:pr-6">
              <span aria-hidden="true" className="relative block h-[11px] w-[11px] rounded-full bg-signal" />
              <h3 className="mt-6 text-2xl font-semibold tracking-[-0.03em]">{step.verb}</h3>
              <p className="mt-3 max-w-[34ch] leading-relaxed text-muted-foreground">{step.text}</p>
              <code className="mt-5 inline-block rounded-md border border-border bg-surface px-2.5 py-1 font-mono text-[0.8125rem] text-foreground/90">
                {step.detail}
              </code>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
